import { Getter } from 'vuex'
import { RootState } from '@/store/types'
import { ArticleGetters, ArticleState } from '../types'
import { ArticleTypeCode } from '@/types/article'

const sectionsTypeForArticle: Getter<ArticleState, RootState> = (
  state,
  getters: ArticleGetters
) => {
  const list = getters['articleTypesList']()

  return list.filter(({ value }) => {
    const code = getters['articleTypeCode'](value)

    return (
      code !== ArticleTypeCode.TOPIC &&
      code !== ArticleTypeCode.BIOGRAPHY &&
      code !== ArticleTypeCode.NOMINEE &&
      code !== ArticleTypeCode.BRAND
    )
  })
}

export default sectionsTypeForArticle
